{
  "name": "royal-canin-ciam-register-web-app",
  "version": "1.33.0",
  "description": "",
  "private": true,
  "scripts": {
    "build": "ng build",
    "build-dev": "npm run build",
    "build-prd": "ng build --configuration=production",
    "build-stg": "ng build --configuration=staging",
    "build-uat": "ng build --configuration=uat",
    "build:analyze": "ng build  --configuration=production  --named-chunks=true && esbuild-visualizer --metadata ./dist/Register-WebApp/stats.json --filename ./dist/Register-WebApp/stats.html --open",
    "ci:quality": "npm run lint:scripts && npm run lint:styles && npm run prettier:check",
    "lint": "ng lint",
    "lint:scripts": "ng lint",
    "lint:styles": "stylelint '**/*.scss'",
    "lint:styles:fix": "stylelint '**/*.scss' --fix",
    "ng": "ng",
    "phrase": "node phrase.js",
    "prettier:check": "prettier ./src --check",
    "prettier:write": "prettier ./src --write",
    "start": "ng serve",
    "test": "jest --maxWorkers=50%",
    "test:ci": "jest --ci --coverage --run-in-band --coverageReporters=cobertura --coverageReporters=lcov --testResultsProcessor=jest-sonar-reporter --no-cache",
    "test:watch": "jest --watch-all",
    "prepare": "husky install .husky"
  },
  "dependencies": {
    "@angular/animations": "~19.2.2",
    "@angular/cdk": "^19.2.3",
    "@angular/common": "~19.2.2",
    "@angular/compiler": "~19.2.2",
    "@angular/core": "~19.2.2",
    "@angular/forms": "~19.2.2",
    "@angular/material": "^19.2.3",
    "@angular/platform-browser": "~19.2.2",
    "@angular/platform-browser-dynamic": "~19.2.2",
    "@angular/router": "~19.2.2",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@okta/okta-angular": "6.4.0",
    "@rc/ui": "^19.1.2",
    "i18n-iso-countries": "^7.14.0",
    "object-path": "^0.11.8",
    "replace-special-characters": "1.2.7",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^11.1.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-builders/jest": "^19.0.0",
    "@angular-devkit/build-angular": "^19.2.3",
    "@angular-eslint/builder": "^19.2.1",
    "@angular-eslint/eslint-plugin": "^19.2.1",
    "@angular-eslint/eslint-plugin-template": "^19.2.1",
    "@angular-eslint/schematics": "^19.2.1",
    "@angular-eslint/template-parser": "^19.2.1",
    "@angular/cli": "^19.2.3",
    "@angular/compiler-cli": "~19.2.2",
    "@angular/language-service": "~19.2.2",
    "@commitlint/cli": "^19.8.0",
    "@commitlint/config-conventional": "^19.8.0",
    "@types/jest": "29.5.14",
    "@types/node": "^22.13.10",
    "@typescript-eslint/eslint-plugin": "^8.26.1",
    "@typescript-eslint/parser": "^8.26.1",
    "@typescript-eslint/utils": "^8.26.1",
    "esbuild-visualizer": "^0.7.0",
    "eslint": "^9.22.0",
    "eslint-config-prettier": "^10.1.1",
    "eslint-plugin-prettier": "^5.2.3",
    "eslint-plugin-unused-imports": "^4.1.4",
    "husky": "^9.1.7",
    "jest": "^29.7.0",
    "jest-preset-angular": "^14.5.3",
    "jest-sonar-reporter": "^2.0.0",
    "lint-staged": "^15.5.0",
    "ng-mocks": "^14.13.4",
    "postcss": "^8.5.3",
    "prettier": "^3.5.3",
    "prettier-eslint": "^16.3.0",
    "prettier-plugin-organize-attributes": "^1.0.0",
    "stylelint": "^16.16.0",
    "stylelint-config-recommended-scss": "^14.1.0",
    "stylelint-order": "^6.0.4",
    "stylelint-scss": "^6.11.1",
    "typescript": "^5.8.2",
    "zod": "^3.24.2"
  },
  "engines": {
    "node": "^18.19.1 || ^20.11.1 || ^22.0.0"
  }
}
